import { Dispatch, useState } from "react";
import styles from "./CommonFields.module.css";
import { Checkbox, Collapsible, FormLayout, Select } from "@shopify/polaris";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { Field } from "@shopify/react-form";
import { Action } from "../Types";
import { WidgetShowOptions } from "../constants";

type Props_GeneralSettings = {
    dispatchBundleConfig: Dispatch<Action>;
    show_bundle_widget: Field<"" | "show_everywhere" | "hide_everywhere" | "hide_product_page">;
    free_shipping: Field<boolean>;
};

const BundleSpecificSettings = ({ dispatchBundleConfig, show_bundle_widget, free_shipping }: Props_GeneralSettings) => {
    const [expandSettings, setExpandSettings] = useState(true);
    return (
        <>
            <div className={styles.sectionTitleWrapper} onClick={() => setExpandSettings((ps) => !ps)}>
                <div>For this Bundle</div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: expandSettings ? "rotate(90deg)" : "rotate(270deg)",
                    }}
                >
                    <MdOutlineArrowBackIosNew size={14} />
                </div>
            </div>
            <Collapsible
                open={expandSettings}
                id="basic-collapsible"
                transition={{
                    duration: "500ms",
                    timingFunction: "ease-in-out",
                }}
                expandOnPrint
            >
                <FormLayout>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <Select
                            label={"Show bundle widget for this bundle"}
                            placeholder={"Bundle widget options"}
                            options={WidgetShowOptions}
                            onChange={(val) => {
                                dispatchBundleConfig({
                                    payload: val,
                                    key: "show_bundle_widget",
                                });
                                show_bundle_widget.onChange(val as any);
                            }}
                            value={show_bundle_widget.value}
                        />
                    </div>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <Checkbox
                            label={"Free Shipping"}
                            {...free_shipping}
                            value=""
                            checked={free_shipping.value}
                            onChange={(val) => {
                                dispatchBundleConfig({
                                    payload: val,
                                    key: "free_shipping",
                                });
                                free_shipping.onChange(val);
                            }}
                        />
                    </div>
                </FormLayout>
            </Collapsible>
        </>
    );
};

export default BundleSpecificSettings;
